import PageTitle from '@alliancesafetycouncil/asc-page-title';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { getCompanies } from '../../../actions/Companies/Companies';
import { clearSites, getSitesByNetwork } from '../../../actions/Sites/Sites';
import FormContainer from '../../../components/FormContainer/FormContainer';
import { getRoles } from '../../../library/Utilities';
import AddUsersForm from './AddUsersForm';

class AddUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      networkId: this.props.match.params.networkId,
      error: false,
      success: false,
      message: null,
      showPassword: false,
    };

    this.props.ClearSites();
    this.props.GetCompanies('asc', 100, 0, 'id');
  }

  handlePasswordVisibility = (e) => {
    e.preventDefault();

    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  render() {
    const { companies, role, dataSite: sites, siteBusy } = this.props;
    const { data, showPassword } = this.state;

    if (!companies) {
      return <div />;
    }

    return (
      <div className="flex flex-1 flex-col">
        <Breadcrumb tag="nav" listTag="div">
          <BreadcrumbItem tag="a" href="#/users" className="bread-crumb-root">
            Users
          </BreadcrumbItem>
          <BreadcrumbItem>Add Users</BreadcrumbItem>
        </Breadcrumb>
        <PageTitle icon="user">Add User</PageTitle>
        <FormContainer
          {...this.props}
          entity="users"
          action="add"
          redirect={'/users'}
          Form={AddUsersForm}
          handleValues={(values) => {
            return {
              name: values.name,
              roles: [values.role],
              sites: ['siteadmin', 'gateguard'].includes(values.role) ? [values.site] : undefined,
              permissions: values.musterAccess ? ['full:muster'] : undefined,
              password: values.password,
              email: values.email,
              phone: values.phone,
              notes: values.notes,
              status: values.status,
            };
          }}
          companies={companies}
          getSites={this.props.GetSitesByNetwork}
          siteBusy={siteBusy}
          sites={sites}
          initialValues={data}
          roles={getRoles(role)}
          handlePasswordVisibility={this.handlePasswordVisibility}
          showPassword={showPassword}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    siteBusy: state.siteService.busy,
    companies: state.companyService.data,
    role: state.authService.role,
    dataSite: state.siteService.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetCompanies: (direction, limit, offset, sort) => dispatch(getCompanies(direction, limit, offset, sort)),
    ClearSites: () => dispatch(clearSites()),
    GetSitesByNetwork: (networkId) => dispatch(getSitesByNetwork(networkId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUsers);
